import GUI, { IGUIProps } from "../GUI";

export default function ChevronLeft(props:IGUIProps){
    const className = props.className ? {className:props.className} : {}
    return <svg {...className} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
}